import React, { useEffect, useState } from "react";
import axios from "axios";

import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";

import API_URL from "../../config";

const Settings = () => {

    const [loading, setLoading] = useState(true);

    const [saving, setSaving] = useState(false);

    const [settings, setSettings] = useState({

        platformName: "",

        platformEmail: "",

        supportPhone: "",

        logoUrl: "",

        language: "English",

        timezone: "Asia/Kolkata",

        smtpHost: "",

        smtpPort: "",

        smtpEmail: "",

        smtpPassword: "",

        emailNotifications: true,

        smsNotifications: false,

        pushNotifications: true,

        allowCandidateRegistration: true,

        allowRecruiterRegistration: true,

        emailVerification: true,

        adminApproval: false,

        sessionTimeout: 30,

        passwordExpiry: 90,

        maintenanceMode: false

    });

    useEffect(() => {

        fetchSettings();

    }, []);

    const fetchSettings = async () => {

        try {

            setLoading(true);

            const response = await axios.get(

                `${API_URL}/admin/settings`

            );

            if (response.data) {

                setSettings({

                    ...settings,

                    ...response.data

                });

            }

        } catch (error) {

            console.error(

                "Error fetching settings:",

                error

            );

        } finally {

            setLoading(false);

        }

    };

    const handleInputChange = (e) => {

        const {

            name,

            value,

            type,

            checked

        } = e.target;

        setSettings((prev) => ({

            ...prev,

            [name]:

                type === "checkbox"

                    ? checked

                    : value

        }));

    };

    const saveSettings = async () => {

        try {

            setSaving(true);

            await axios.put(

                `${API_URL}/admin/settings`,

                settings

            );

            alert("Settings saved successfully.");

        } catch (error) {

            console.error(

                "Error saving settings:",

                error

            );

            alert("Failed to save settings.");

        } finally {

            setSaving(false);

        }

    };

    const resetSettings = () => {

        fetchSettings();

    };
        if (loading) {

        return (

            <Loader
                fullScreen={true}
                text="Loading Settings..."
            />

        );

    }

    return (

        <div className="space-y-6">

            <PageHeader

                title="Settings"

                subtitle="Manage HIRECURA platform configuration"

                showButton={false}

                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Settings"
                    }
                ]}

            />

           <div className="bg-white rounded-3xl shadow-lg p-6">

                <div className="border-b border-gray-200 pb-4 mb-6">

                        <h2 className="text-xl font-semibold text-gray-800">

                        General Settings

                    </h2>

                </div>

                <div className="card-body">

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div className="col-md-6 mb-3">

                            <label className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500">

                                Platform Name

                            </label>

                            <input
                                type="text"
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="platformName"
                                value={settings.platformName}
                                onChange={handleInputChange}
                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500">

                                Platform Email

                            </label>

                            <input
                                type="email"
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="platformEmail"
                                value={settings.platformEmail}
                                onChange={handleInputChange}
                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500">

                                Support Phone

                            </label>

                            <input
                                type="text"
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="supportPhone"
                                value={settings.supportPhone}
                                onChange={handleInputChange}
                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500">

                                Logo URL

                            </label>

                            <input
                                type="text"
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="logoUrl"
                                value={settings.logoUrl}
                                onChange={handleInputChange}
                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500">

                                Default Language

                            </label>

                            <select
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="language"
                                value={settings.language}
                                onChange={handleInputChange}
                            >

                                <option value="English">

                                    English

                                </option>

                                <option value="Hindi">

                                    Hindi

                                </option>

                                <option value="Telugu">

                                    Telugu

                                </option>

                            </select>

                        </div>

                        <div className="col-md-6 mb-3">

                            <label className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500">

                                Time Zone

                            </label>

                            <select
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="timezone"
                                value={settings.timezone}
                                onChange={handleInputChange}
                            >

                                <option value="Asia/Kolkata">

                                    Asia/Kolkata

                                </option>

                                <option value="UTC">

                                    UTC

                                </option>

                                <option value="America/New_York">

                                    America/New_York

                                </option>

                                <option value="Europe/London">

                                    Europe/London

                                </option>

                            </select>

                        </div>

                    </div>

                </div>

            </div>
                        <div className="bg-white rounded-3xl shadow-lg p-6">

                
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <h2 className="text-xl font-semibold text-gray-800">
                        Email Configuration

                    </h2>

                </div>

                <div className="card-body">

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div className="col-md-6 mb-3">

                            <label className="block text-sm font-medium text-gray-600 mb-2">

                                SMTP Host

                            </label>

                            <input
                                type="text"
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="smtpHost"
                                value={settings.smtpHost}
                                onChange={handleInputChange}
                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label className="block text-sm font-medium text-gray-600 mb-2">

                                SMTP Port

                            </label>

                            <input
                                type="number"
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="smtpPort"
                                value={settings.smtpPort}
                                onChange={handleInputChange}
                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label className="block text-sm font-medium text-gray-600 mb-2">

                                SMTP Email

                            </label>

                            <input
                                type="email"
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="smtpEmail"
                                value={settings.smtpEmail}
                                onChange={handleInputChange}
                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label className="block text-sm font-medium text-gray-600 mb-2">

                                SMTP Password

                            </label>

                            <input
                                type="password"
                                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                name="smtpPassword"
                                value={settings.smtpPassword}
                                onChange={handleInputChange}
                            />

                        </div>

                    </div>

                </div>

            </div>

            <div className="bg-white rounded-3xl shadow-lg p-6">

                <div className="border-b border-gray-200 pb-4 mb-6">

<h2 className="text-xl font-semibold text-gray-800">

                        Notification Settings

                    </h2>

                </div>

                <div className="card-body">

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div className="col-md-4 mb-3">

                            <label className="flex items-center justify-between rounded-2xl border border-gray-200 p-4 cursor-pointer">

<span className="font-medium text-gray-700">
Email Notifications
</span>

<input
type="checkbox"
className="h-5 w-5 rounded text-teal-600 focus:ring-teal-500"
/>

</label>

                        </div>

                        <div className="col-md-4 mb-3">

                            <div className="form-check form-switch">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="smsNotifications"
                                    name="smsNotifications"
                                    checked={settings.smsNotifications}
                                    onChange={handleInputChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="smsNotifications"
                                >

                                    SMS Notifications

                                </label>

                            </div>

                        </div>

                        <div className="col-md-4 mb-3">

                            <div className="form-check form-switch">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="pushNotifications"
                                    name="pushNotifications"
                                    checked={settings.pushNotifications}
                                    onChange={handleInputChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="pushNotifications"
                                >

                                    Push Notifications

                                </label>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

            <div className="bg-white rounded-3xl shadow-lg p-6">

                <div className="border-b border-gray-200 pb-4 mb-6">

                    <h2 className="text-xl font-semibold text-gray-800">

                        Security & Registration

                    </h2>

                </div>

                <div className="card-body">

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div className="col-md-6">

                            <div className="form-check form-switch mb-3">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="allowCandidateRegistration"
                                    name="allowCandidateRegistration"
                                    checked={settings.allowCandidateRegistration}
                                    onChange={handleInputChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="allowCandidateRegistration"
                                >

                                    Allow Candidate Registration

                                </label>

                            </div>

                            <div className="form-check form-switch mb-3">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="allowRecruiterRegistration"
                                    name="allowRecruiterRegistration"
                                    checked={settings.allowRecruiterRegistration}
                                    onChange={handleInputChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="allowRecruiterRegistration"
                                >

                                    Allow Recruiter Registration

                                </label>

                            </div>

                            <div className="form-check form-switch mb-3">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="emailVerification"
                                    name="emailVerification"
                                    checked={settings.emailVerification}
                                    onChange={handleInputChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="emailVerification"
                                >

                                    Require Email Verification

                                </label>

                            </div>

                            <div className="form-check form-switch">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="adminApproval"
                                    name="adminApproval"
                                    checked={settings.adminApproval}
                                    onChange={handleInputChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="adminApproval"
                                >

                                    Require Admin Approval

                                </label>

                            </div>

                        </div>

                        <div className="col-md-6">

                            <div className="mb-3">

                                <label className="block text-sm font-medium text-gray-600 mb-2">

                                    Session Timeout (Minutes)

                                </label>

                                <input
                                    type="number"
                                    className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                    name="sessionTimeout"
                                    value={settings.sessionTimeout}
                                    onChange={handleInputChange}
                                />

                            </div>

                            <div className="mb-3">

                                <label className="block text-sm font-medium text-gray-600 mb-2">

                                    Password Expiry (Days)

                                </label>

                                <input
                                    type="number"
                                    className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                    name="passwordExpiry"
                                    value={settings.passwordExpiry}
                                    onChange={handleInputChange}
                                />

                            </div>

                            <div className="form-check form-switch">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="maintenanceMode"
                                    name="maintenanceMode"
                                    checked={settings.maintenanceMode}
                                    onChange={handleInputChange}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="maintenanceMode"
                                >

                                    Enable Maintenance Mode

                                </label>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
                       <div className="bg-white rounded-3xl shadow-lg p-6">

                <div className="flex justify-end gap-4">

                    <button
                        type="button"
                        className="px-6 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
                        onClick={resetSettings}
                        disabled={saving}
                    >

                        Reset

                    </button>

                    <button
                        type="button"
                        className="px-6 py-2 rounded-xl bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-60"
                        onClick={saveSettings}
                        disabled={saving}
                    >

                        {saving ? "Saving..." : "Save Settings"}

                    </button>

                </div>

            </div>

        </div>

    );

};

export default Settings;